<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-card>
        <EXCMCaseForm
          v-if="item"
          :handle-submit="onSendForm"
          :handle-update-field="updateField"
          :values="item"
          :errors="violations"
          :initial-values="retrieved"
        />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import EXCMCaseForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMCaseForm,
    Loader
  },

  data () {
    return {
      prevRoute: '',
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('cases', 'EXCMCaseUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmcase/update/isLoading',
      error: 'excmcase/update/error',
      deleteError: 'excmcase/del/error',
      deleteLoading: 'excmcase/del/isLoading',
      created: 'excmcase/create/created',
      deleted: 'excmcase/del/deleted',
      retrieved: 'excmcase/update/retrieved',
      updated: 'excmcase/update/updated',
      violations: 'excmcase/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMCaseList' })
    },

    updated: function (updated) {
      this.$router.push({ name: 'EXCMCaseShow', params: { id: updated['@id'] } })
    },
    retrieved: function (retrieved) {
      retrieved.caseProblems = retrieved.caseProblems.map(entry => {
        return { '@id': entry['@id'], idCase: this.$route.params.id, idProblem: entry.idProblem['@id'] || entry.idProblem }
      })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmcase/create/reset',
      deleteItem: 'excmcase/del/del',
      delReset: 'excmcase/del/reset',
      retrieve: 'excmcase/update/retrieve',
      updateReset: 'excmcase/update/reset',
      update: 'excmcase/update/update',
      updateRetrieved: 'excmcase/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmcase ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      let item = Object.assign({}, this.item)
      if (item.status && item.status['@id']) {
        item.status = item.status['@id']
      }
      if (this.retrieved.contractorUserData === '') {
        this.retrieved.contractorUserData = null
      }
      if (this.retrieved.partnerUserData === '') {
        this.retrieved.partnerUserData = null
      }
      this.$store.state.excmcustomfield.update.retrieved = item
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
